// Gruppierung des Posteingangs je E-Mail (Kundenfeedback 11.09.26, III./V.).
//
// Das Backend legt pro Anhang einen Eintrag an (jeder Anhang kann einzeln
// einem Fall zugeordnet werden). Eine weitergeleitete Outlook-Mail mit zwei
// eingebetteten Bildern erschien dadurch als zwei scheinbar identische
// E-Mails – "einmal mit Inhalt, einmal ohne". In der Anzeige werden alle
// Einträge derselben E-Mail (gleiche messageId) zu EINEM Listeneintrag
// gebündelt; die Anhänge stehen darunter und lassen sich einzeln öffnen.

export interface InboxItemLike {
  id: number;
  source?: string;
  messageId?: string;
  status?: string;
  receivedAt?: string;
  [key: string]: unknown;
}

export interface InboxGroup<T extends InboxItemLike = InboxItemLike> {
  /** Stabiler Schlüssel: "mail:<messageId>" oder "item:<id>". */
  key: string;
  /** Repräsentant für Absender/Betreff/Datum (erster Eintrag der Gruppe). */
  primary: T;
  /** Alle Einträge der Gruppe in Listenreihenfolge (mind. einer). */
  items: T[];
}

/** Liefert den Gruppenschlüssel eines Eintrags. */
export function inboxGroupKey(item: InboxItemLike): string {
  const source = item.source || "email";
  const messageId = String(item.messageId || "").trim();
  if (source === "email" && messageId) return `mail:${messageId}`;
  return `item:${item.id}`;
}

/**
 * Bündelt Einträge derselben E-Mail. Die Reihenfolge der Gruppen folgt dem
 * ersten Auftreten in der Eingabeliste (die Liste kommt bereits nach
 * Empfangsdatum sortiert vom Backend).
 */
export function groupInboxItems<T extends InboxItemLike>(items: T[]): InboxGroup<T>[] {
  const byKey = new Map<string, InboxGroup<T>>();
  const ordered: InboxGroup<T>[] = [];
  for (const item of items) {
    const key = inboxGroupKey(item);
    const existing = byKey.get(key);
    if (existing) {
      existing.items = [...existing.items, item];
      continue;
    }
    const group: InboxGroup<T> = { key, primary: item, items: [item] };
    byKey.set(key, group);
    ordered.push(group);
  }
  return ordered;
}
